import { render, staticRenderFns } from "./BedRestAccounting.vue?vue&type=template&id=584e38d4&scoped=true"
import script from "./BedRestAccounting.vue?vue&type=script&lang=js"
export * from "./BedRestAccounting.vue?vue&type=script&lang=js"
import style0 from "./BedRestAccounting.vue?vue&type=style&index=0&id=584e38d4&prod&scoped=true&lang=css"
import style1 from "./BedRestAccounting.vue?vue&type=style&index=1&id=584e38d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584e38d4",
  null
  
)

export default component.exports